import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { UiActions } from 'state/actions/UiActions';
import { Question } from './Question';

class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0,

      loaded: false,

      error: false,
      errorMessage: null,

      feedback: null,
      questionIndex: [],
      questionMapById: {},
      nextQuestion: null,

      disabled: true,

      send: false,
      sendSuccess: false,
      sendSuccessData: null,
      sendSuccessMessage: null,
      sendFailure: false,
      sendFailureMessage: null,
    };
  }

  componentDidMount() {
    const { isProduct, token, id } = this.props;

    this.setState({
      loaded: false,
    });

    let endpoint =
      isProduct === true
        ? GlamboxEndpoints.Feedback.getProductFeedback
        : GlamboxEndpoints.Feedback.getEditionFeedbackForm;

    let requestData = {};

    if (isProduct === true) {
      requestData.productId = id;
    } else {
      requestData.formId = id;
    }

    ExecuteRequest(
      endpoint,
      requestData,
      'GET',
      {
        Authorization: token.Authorization,
      },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          // Define tudo como false
          this._setSelectedToFalse(result);

          // Mapeia questões pelo questionId
          let questionsMappedById = {};
          for (let i = 0; i < result.questions.length; i++) {
            questionsMappedById[result.questions[i].questionId] = i;

            if (result.questions[i].options.length === 1) {
              result.questions[i].options[0].textValue = '';
            }
          }

          this.setState({
            loaded: true,
            feedback: result,
            questionMapById: questionsMappedById,
          });
        } else {
          this.setState({
            loaded: true,
            error: true,
            errorMessage:
              result && result.message ? result.message : 'Erro desconhecido',
          });
        }
      }
    );
  }

  render() {
    const { props, state } = this;

    const { person } = props;

    if (state.loaded === false) {
      return (
        <div className={'p-xl-5 p-3 level-2 feedback-page'}>
          <p className={'text-center'}>Carregando...</p>
        </div>
      );
    }

    if (state.send === true) {
      return (
        <div className={'p-xl-5 p-3 level-2 feedback-page'}>
          <p className={'text-center'}>Enviando...</p>
        </div>
      );
    }

    if (state.error === true) {
      return (
        <div className={'p-xl-5 p-3 level-2 feedback-page'}>
          <h2>Ops!</h2>
          <p className={'text-center lead'}>{state.errorMessage}</p>
          <p className={'text-center'}>
            <button className={'btn btn-sm btn-light-pink'} onClick={() => {}}>
              Fechar
            </button>
          </p>
        </div>
      );
    }

    if (state.sendFailure === true) {
      return (
        <div className={'p-xl-5 p-3 level-2 feedback-page'}>
          <h2>Ops!</h2>
          <p className={'text-center lead'}>{state.sendFailureMessage}</p>
          <p className={'text-center'}>
            <button
              className={'btn btn-sm btn-light-pink'}
              onClick={this.finishFeedback}
            >
              Fechar
            </button>
          </p>
        </div>
      );
    }

    if (state.sendSuccess === true) {
      let sentMessage = null;

      if (this.props.isOpen === true) {
        sentMessage =
          'Seu feedback foi enviado com sucesso! Obrigado por participar de nossa pesquisa!';
      } else {
        let points = 0;
        if (
          state.sendSuccessData.form_glampoints > 0 &&
          state.sendSuccessData.is_first_answer === true
        ) {
          let multiplier =
            person.badge !== null && person.badge.badgeId >= 5 ? 2 : 1;

          points = parseInt(state.sendSuccessData.form_glampoints) * multiplier;
        }
        sentMessage = 'Você recebeu ' + points + ' Glampoints. ';
        sentMessage += state.sendSuccessMessage;
      }

      return (
        <div className={'p-xl-5 p-3 level-2 feedback-page'}>
          <h2>Obrigada por dar seu feedback!</h2>
          <p className={'text-center lead'}>{sentMessage}</p>
          <p className={'text-center'}>
            <button
              className={'btn btn-sm btn-light-pink'}
              onClick={this._finishFeedback}
            >
              Finalizar
            </button>
          </p>
        </div>
      );
    }

    return (
      <div className={'p-xl-5 p-3 level-2 feedback-page'}>
        <h2>{state.feedback.formTitle}</h2>
        {this._renderProgressBar()}
        {this._renderQuestions()}

        <div className="action">
          {this._renderPrevButton()}
          {this._renderNextButton()}
        </div>
      </div>
    );
  }

  // --------------------------------------------------------------------

  _finishFeedback = e => {
    e.preventDefault();

    if (this.props.onFinish) this.props.onFinish(true);
  };

  _renderProgressBar = () => {
    const { current, feedback } = this.state;

    if (current >= feedback.questions.length - 1) return null;

    let percent =
      parseFloat(((current + 1) / feedback.questions.length) * 100).toFixed(2) +
      '%';

    return (
      <div className="linha-status">
        <div className="body-progress">
          <div className="progress">
            <div className="bar" style={{ width: percent }}></div>
          </div>
          <div className="question-number">
            Questão {current + 1} de {feedback.questions.length}
          </div>
        </div>
      </div>
    );
  };

  _onSubmit = () => {
    let { id, token, isProduct } = this.props;

    let { current, questionIndex, feedback } = this.state;

    let requestData = {},
      requestParam = {};

    this.setState({
      send: true,
    });

    if (!questionIndex.includes(current)) questionIndex.push(current);

    let questions = {};

    for (let i = 0; i < feedback.questions.length; i++) {
      let question = feedback.questions[i],
        answers = [],
        r;

      for (let j = 0; j < question.options.length; j++) {
        if (
          question.typeId === 2 ||
          question.typeId === 5 ||
          question.typeId === 6
        ) {
          answers.push(question.options[j].textValue);
        } else {
          if (question.options[j].is_selected) {
            answers.push(question.options[j].optionId);
          }
        }
      }

      r = answers.join();
      questions['Q' + question.questionId] = r;
    }

    if (isProduct === true) {
      requestParam.productId = id;
    } else {
      requestParam.formId = id;
    }

    let endpoint =
      isProduct === true
        ? GlamboxEndpoints.Feedback.createProductFeedback
        : GlamboxEndpoints.Feedback.createEditionFeedback;

    requestData = Object.assign({}, requestData, questions);

    ExecuteRequest(
      endpoint,
      requestData,
      'POST',
      {
        Authorization: token.Authorization,
      },
      requestParam,
      this.feedbackRequestCallback
    );
  };

  renderMessage = response => {
    const { result, statusCode } = response;

    let message = result?.message;

    if (!message || statusCode === 500) {
      message = 'Ops, um erro aconteceu! Tente novamente mais tarde.';

      return message;
    }

    return message;
  };

  feedbackRequestCallback = response => {
    const { result, statusCode } = response;

    if (statusCode === 200) {
      this.setState({
        send: false,
        sendSuccess: true,
        sendSuccessMessage:
          'Seu feedback foi enviado com sucesso! Continue preenchendo para receber mais Glampoints!',
        sendSuccessData: result,
      });
      this.props.publishSuccessAlert('Feedback enviado com sucesso!');
    } else {
      this.setState({
        send: false,
        sendFailure: true,
        sendFailureMessage: this.renderMessage(response),
      });

      this.props.publishErrorAlert(this.renderMessage(response));
    }
  };

  _renderPrevButton = () => {
    let { current } = this.state;

    if (current > 0) {
      let _cls = ['btn', 'btn-small', 'btn-outline-light-pink'];

      return (
        <button className={classnames(_cls)} onClick={this._prevQuestion}>
          Anterior
        </button>
      );
    }
  };

  _renderNextButton = () => {
    let { current, nextQuestion, feedback } = this.state;

    let disabled = nextQuestion === null;

    if (nextQuestion !== -1 && current < feedback.questions.length - 1) {
      let _cls = ['btn', 'btn-small', 'btn-light-pink'];

      return (
        <button
          className={classnames(_cls)}
          onClick={this._nextQuestion}
          disabled={disabled}
        >
          Avançar
        </button>
      );
    } else {
      return (
        <button
          className={'btn btn-sm btn-light-line'}
          disabled={disabled}
          onClick={this._onSubmit}
        >
          Enviar
        </button>
      );
    }
  };

  _prevQuestion = () => {
    let { current, nextQuestion, prevQuestion, feedback, questionIndex } =
      this.state;

    nextQuestion = current;
    current = questionIndex.pop();

    this.setState({
      nextQuestion,
      current,
    });

    this.forceUpdate();
  };

  _nextQuestion = () => {
    let { current, nextQuestion, feedback, questionIndex } = this.state;

    if (!questionIndex.includes(current)) questionIndex.push(current);

    current = nextQuestion;
    nextQuestion = null;

    this.setState(
      {
        current,
        nextQuestion,
      },
      () => {
        let question = feedback.questions[current];

        let canMoveNext = question.options.filter(item => {
          return item.is_selected === true;
        });

        if (canMoveNext.length > 0) {
          this._updateQuestion(question);
        }
      }
    );

    this.forceUpdate();
  };

  _renderQuestions = () => {
    let { current, feedback } = this.state;

    let question = feedback.questions[current];

    return <Question question={question} onUpdate={this._updateQuestion} />;
  };

  _setSelectedToFalse = feedback => {
    for (let q = 0; q < feedback.questions.length; q++) {
      for (let o = 0; o < feedback.questions[q].options.length; o++) {
        feedback.questions[q].options[o].is_selected = false;
      }
      feedback.questions[q].selected = 'title';
    }
  };

  _updateQuestion = question => {
    let { current, feedback, questionIndex, questionMapById, nextQuestion } =
      this.state;

    if (question && question.questionId) {
      for (let n = 0; n < feedback.questions.length; n++) {
        if (feedback.questions[n].questionId === question.questionId) {
          feedback.questions[n] = question;
        }
      }
    }

    nextQuestion = null;

    let canMoveNext = question.options.filter(item => {
      return item.is_selected === true;
    });

    let nextStepOk = [...canMoveNext];

    if (canMoveNext.length > 0) {
      //if (!questionIndex.includes(current)) questionIndex.push(current);

      let optionsThatDontFinish = canMoveNext.filter(item => {
        return item.nextQuestionId !== -1;
      });

      let shouldFinish =
        current === feedback.questions.length - 1 ||
        !(optionsThatDontFinish.length > 0);

      if (shouldFinish) {
        nextQuestion = -1;
      } else {
        let actualOrder = 999,
          nextQuestionId = 0;

        for (let i = 0; i < nextStepOk.length; i++) {
          for (let j = 0; j < feedback.questions.length; j++) {
            if (
              feedback.questions[j].questionId ===
                nextStepOk[i].nextQuestionId &&
              feedback.questions[j].questionOrder < actualOrder
            ) {
              actualOrder = feedback.questions[j].questionOrder;
              nextQuestionId = nextStepOk[i].nextQuestionId;
            }
          }
        }

        if (nextQuestionId > 0) {
          nextQuestion = questionMapById[nextQuestionId];
        } else {
          nextQuestion = current + 1;
        }
      }
    }

    this.setState({
      current,
      feedback,
      questionIndex,
      nextQuestion,
    });
  };
}

Feedback.defaultProps = {
  isProduct: false,
  isOpen: false,
};

Feedback.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onFinish: PropTypes.func.isRequired,
  isProduct: PropTypes.bool,
  isOpen: PropTypes.bool,
};

const mapStateToProps = state => ({
  token: state.token.data,
  person: state.person.data,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    UiActions.publishSuccessAlert(message);
  },
  publishErrorAlert: message => {
    UiActions.publishErrorAlert(message);
  },
});

Feedback = connect(mapStateToProps, mapDispatchToProps)(Feedback);

export { Feedback };
